export enum FinancialAnnexesCategoryEnum {
  KFI1 = 'KFI1',
  KFI2 = 'KFI2',
  KFI3 = 'KFI3',
  KFI4 = 'KFI4',
  KFI5 = 'KFI5',
  KFI6 = 'KFI6',
}
